/* NOVSIX · поведение страниц: выбор варианта на карточке семьи, фильтры коллекции, ролики, галерея, липкая полоса. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* карточка семьи: ?v=ASIN или handle страницы Shopify → выбранный вариант; выбор меняет фото, цену, тон, ссылку */
  var pdp = $('.nx-pdp');
  if (pdp) {
    var V = JSON.parse($('.nx-vjson', pdp).textContent), ids = Object.keys(V);
    var q = new URLSearchParams(location.search).get('v');
    var cur = V[q] ? q : null;
    if (!cur && window.NXH) ids.forEach(function (a) { if (!cur && V[a].h === window.NXH) cur = a; });
    if (!cur) cur = pdp.getAttribute('data-main');
    var pick = function (k, v) {
      var c = V[cur], want = { f: c.f, s: c.s, n: c.n }; want[k] = v;
      var best = null, score = -1;
      ids.forEach(function (a) {
        var x = V[a], sc = (x.f === want.f ? 4 : 0) + (String(x.s) === String(want.s) ? 2 : 0) + (String(x.n) === String(want.n) ? 2 : 0);
        if (String(x[k]) !== String(v)) sc = -1;
        if (sc > score) { score = sc; best = a; }
      });
      if (best) set(best, true);
    };
    var set = function (a, push) {
      cur = a; var x = V[a];
      $$('[data-out="p"]').forEach(function (n) { n.textContent = x.p; });
      $$('[data-out="f"]').forEach(function (n) { n.textContent = x.f; });
      $$('[data-out="t"]').forEach(function (n) { n.textContent = x.t; });
      $$('[data-out="s"]').forEach(function (n) { n.textContent = x.s || ''; });
      $$('[data-out="n"]').forEach(function (n) { n.textContent = x.nl || ('Set of ' + x.n); });
      $$('.nx-buy-btn').forEach(function (b) {
        b.href = x.b; b.setAttribute('data-asin', a);
        var l = $('[data-out="bl"]', b); if (l) l.textContent = x.st ? 'Buy on Amazon' : 'Check availability on Amazon';
      });
      $$('[data-out-html="r"]').forEach(function (n) { n.innerHTML = x.r; });   // критик r2 №3: рейтинг варианта (настенные)
      var im = $('.nx-gal-pk', pdp); if (im) { im.srcset = x.ss; im.src = x.i; im.alt = im.alt.split(',')[0] + ', ' + x.f; }
      var th = $('.nx-th-pk', pdp); if (th) { th.srcset = x.ss; th.src = x.i; }   // r3 №1, r5 №13: srcset варианта
      // Atelier: первой — сцена, но только если на ней та же отделка, что у выбранного варианта (критик сайта r3); выбор цвета — пэкшот
      var s0 = $('.nx-slide[data-f]', pdp);
      if (push || (s0 && s0.getAttribute('data-f') && s0.getAttribute('data-f') !== x.f)) showSlide('pk');
      // критик сайта r5: сцены другого цвета, чем выбранный вариант, в галерее не показываем
      $$('.nx-th', pdp).forEach(function (t) {
        var k = t.getAttribute('data-main'); if (k === 'pk') return;
        var sl = $('.nx-slide[data-slide="' + k + '"]', pdp), f = sl && sl.getAttribute('data-f');
        t.hidden = !!(f && f !== x.f);
        if (t.hidden && sl && !sl.hidden) showSlide('pk');
      });
      $$('.nx-sw', pdp).forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-v') === x.f); b.setAttribute('aria-pressed', b.getAttribute('data-v') === x.f); });
      $$('.nx-seg button', pdp).forEach(function (b) {
        var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
        b.classList.toggle('on', String(x[k]) === v); b.setAttribute('aria-pressed', String(x[k]) === v);
        b.disabled = !ids.some(function (o) { return V[o].f === x.f && String(V[o][k]) === v; });
      });
      $$('.nx-scale-r', pdp).forEach(function (r) { r.classList.toggle('on', r.getAttribute('data-sz') === x.s); });
      if (push && history.replaceState) { var u = new URL(location.href); u.searchParams.set('v', a); history.replaceState(null, '', u); }
    };
    var showSlide = function (k) {
      $$('.nx-slide', pdp).forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== k; });
      $$('.nx-th', pdp).forEach(function (t) { t.classList.toggle('on', t.getAttribute('data-main') === k); });
    };
    $$('.nx-th', pdp).forEach(function (t) { t.addEventListener('click', function () { showSlide(t.getAttribute('data-main')); }); });
    $$('.nx-sw', pdp).forEach(function (b) { b.addEventListener('click', function () { pick('f', b.getAttribute('data-v')); }); });
    $$('.nx-seg button', pdp).forEach(function (b) { b.addEventListener('click', function () { pick(b.getAttribute('data-k'), b.getAttribute('data-v')); }); });
    set(cur, false);
    var st = $('.nx-sticky'), bb = $('.nx-buy .nx-buy-btn');
    if (st && bb) {   // r7 №1: полоса только после того, как основная Buy ушла вверх за экран (и при любом прыжке прокрутки)
      var upd = function () { st.hidden = bb.getBoundingClientRect().bottom > 0; };
      window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();   // критик r2 №1: одна кнопка Buy на экране
    }
  }

  /* фильтры коллекции */
  var grid = $('.nx-cgrid');
  if (grid) {
    var f = { fam: '', fin: '' };
    var apply = function () {
      var n = 0;
      $$('.nx-card', grid).forEach(function (c) {
        var ok = (!f.fam || c.getAttribute('data-fam') === f.fam) && (!f.fin || c.getAttribute('data-fin') === f.fin);
        c.hidden = !ok; if (ok) n++;
      });
      var em = $('.nx-empty'); if (em) em.hidden = n > 0;
    };
    $$('.nx-chips').forEach(function (g) {
      var key = g.getAttribute('data-key');
      $$('button', g).forEach(function (b) {
        b.setAttribute('aria-pressed', b.classList.contains('on'));
        b.addEventListener('click', function () {
          $$('button', g).forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
          b.classList.add('on'); b.setAttribute('aria-pressed', 'true'); f[key] = b.getAttribute('data-v'); apply();
        });
      });
    });
    var p = new URLSearchParams(location.search);
    ['fam', 'fin'].forEach(function (k) { var v = p.get(k); if (v) { var b = $('.nx-chips[data-key="' + k + '"] button[data-v="' + v + '"]'); if (b) b.click(); } });
  }

  /* ролики: тизер без звука по нажатию */
  $$('.nx-vid-b').forEach(function (b) {
    b.addEventListener('click', function () {
      if ($('video', b)) return;
      var v = document.createElement('video');
      v.src = b.getAttribute('data-src'); v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true; v.setAttribute('playsinline', '');
      var im = $('img', b); if (im) v.poster = im.currentSrc || im.src;
      b.innerHTML = ''; b.appendChild(v); v.play().catch(function () {});
    });
  });

  /* мобильное меню закрывается по ссылке */
  $$('.nx-mnav a').forEach(function (a) { a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.open = false; }); });
  /* Atelier, критик сайта r3: меню телефона — под шапкой (кнопка остаётся видна и становится «×»), закрывается Esc и тапом мимо */
  var bg = $('.nx-burger');
  if (bg) {
    var place = function () { var hd = $('.nx-hd'), m = $('.nx-mnav', bg); if (hd && m) m.style.top = Math.max(0, hd.getBoundingClientRect().bottom) + 'px'; };
    bg.addEventListener('toggle', function () { if (bg.open) place(); document.documentElement.style.overflow = bg.open ? 'hidden' : ''; });
    window.addEventListener('resize', function () { if (bg.open) place(); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && bg.open) bg.open = false; });
    document.addEventListener('click', function (ev) { if (bg.open && !bg.contains(ev.target)) bg.open = false; });
  }

  /* Atelier, фильмы о предметах: 16:9 или 9:16 по ширине экрана; файл грузится, только когда плитка у экрана; без звука, по кругу;
     «меньше движения» в системе — остаётся обложка */
  var fv = $$('.nx-film-v');
  if (fv.length) {
    var mq = window.matchMedia('(max-width:700px)'), narrow = mq.matches, still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var go = function (v, on) {
      if (on && !v.poster) v.poster = v.getAttribute(narrow ? 'data-pv' : 'data-ph');   // критик f2: обложка тоже только у экрана
      if (on && !still) {
        if (!v.src) {   // критик f1: ролики не стартуют синхронно — у каждого свой сдвиг начала
          v.src = v.getAttribute(narrow ? 'data-v' : 'data-h');
          var i = fv.indexOf(v); v.addEventListener('loadedmetadata', function () { if (v.duration) v.currentTime = (i * 2.3) % v.duration; }, { once: true });
        }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      else if (!on && v.src) v.pause();
      if (on && v.dataset.held === '1') v.pause();
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (x) { go(x.target, x.isIntersecting); }); }, { rootMargin: '200px 0px' });
      fv.forEach(function (v) { io.observe(v); });
    } else fv.forEach(function (v) { go(v, true); });
    var flip = function () {   // поворот экрана: 16:9 ↔ 9:16 — сбросить файл и обложку, плитки у экрана догрузятся заново
      narrow = mq.matches;
      fv.forEach(function (v) {
        var vis = v.src && !v.paused; v.pause(); v.removeAttribute('src'); v.load();
        v.poster = v.getAttribute(narrow ? 'data-pv' : 'data-ph');   // на паузе после поворота — обложка нового формата
        if (vis) go(v, true);
      });
    };
    if (mq.addEventListener) mq.addEventListener('change', flip); else if (mq.addListener) mq.addListener(flip);
    fv.forEach(function (v) {   // критик f3: пауза по нажатию (и снова — продолжить)
      v.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); v.click(); } });
      v.addEventListener('click', function () { if (v.paused) { if (!v.src) go(v, true); else v.play(); v.dataset.held = ''; } else { v.pause(); v.dataset.held = '1'; } });
    });
  }
})();
